@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.create-transfer-order-drawer {
  text-align: left;
  max-width: 1480px;
  margin: auto;
}

.drawer-header {
  font-size: 16px;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
}

.loading-container {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.step-detective {
  width: 50%;
  margin: @space-32 auto @space-24 auto;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
  overflow-y: auto;
  background: var(--gray-F9FAFB);
  padding: @space-24;
  margin: @space-0 @space-32 @space-16 @space-32;
}

.drawer-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--grey-300);
  padding: @space-24 @space-48;
  background: var(--white);
  justify-content: flex-end;
}

.content-container {
  border: 1px solid var(--grey-300);
  background-color: var(--white);
  border-radius: 4px;
}

.section-header {
  padding: @space-16 @space-16 @space-0 @space-16;
}

.section {
  padding: @space-16;
}

.horizontal-divider {
  border-color: var(--grey-300);
  width: calc(100% - @space-32);
  margin: @space-16 auto;
}

.warehouse-dropdown {
  flex: 1;
}

.warehouse-hint {
  color: var(--grey-600);
}

.additional-fields-container {
  margin-top: @space-16;
}

.additional-fields-left {
  flex: 1;
}

.field-container {
  flex: 1;
}

.notes-input-wrapper {
  flex: 1;
  min-height: 68px;
}

.required-indicator {
  color: var(--red-500);
}

.date-picker {
  display: flex;
  height: 32px;
  width: 100%;
  background-color: var(--white);
  input {
    height: 32px;
    border: 1px solid var(--grey-500);
    border-right: none;
  }
  button {
    height: 32px;
    border: 1px solid var(--grey-500);
    display: flex;
  }
}

.product-search-section {
  margin-bottom: @space-16;
  width: calc(50% - @space-12);
}

.footer-last-step {
  flex: 1;
  justify-content: space-between;
}

.back-button-icon {
  width: 14px;
  height: 14px;
  color: inherit;
}
